import * as React from 'react';
import * as moment from 'moment-timezone';
import { st, classes } from './WeeklyDesktopDatesHeader.st.css';
import { Text } from 'wix-ui-tpa';
import { getCurrentWeek } from '../../../utils/momentTimezoneUtils';
import capitalize from '../../../utils/stringUtils';
import WixStylesContext from '../../../context/wixStylesContext';
import WeeklyContext from '../../../context/weeklyContext';
var WeeklyDesktopDatesHeader = function () {
    var isLeft = React.useContext(WixStylesContext).isLeft;
    var _a = React.useContext(WeeklyContext), firstDay = _a.firstDay, dateOnFocuse = _a.dateOnFocuse, locale = _a.locale, calendarRef = _a.calendarRef;
    var _b = React.useState(40), axisWidth = _b[0], setAxisWidth = _b[1];
    var _c = React.useState(getCurrentWeek(firstDay, dateOnFocuse, locale)), currentWeek = _c[0], setCurrentWeek = _c[1];
    var _d = React.useState(moment().format('YYYY-MM-DD')), loadDate = _d[0], setLoadDate = _d[1];
    React.useEffect(function () {
        var dateChangeCheck = function () {
            setInterval(function () {
                var currentDate = moment().format('YYYY-MM-DD');
                if (loadDate !== currentDate) {
                    setLoadDate(currentDate);
                    //@ts-ignore
                    if (calendarRef.current) {
                        //@ts-ignore
                        calendarRef.current.getApi().today();
                    }
                    else {
                        location.reload(); // if state change doesnt halp - try location.reload();
                    }
                }
            }, 1000 * 60 * 60); // 3_600_000) // every hour check if date change
        };
        dateChangeCheck();
    }, [loadDate]);
    React.useEffect(function () {
        setCurrentWeek(getCurrentWeek(firstDay, dateOnFocuse, locale));
    }, [firstDay, dateOnFocuse, locale]);
    React.useEffect(function () {
        var getAxisWidth = function () {
            if (document.getElementsByClassName('fc-timegrid-axis-frame').length > 0) {
                var todayCellWidth = document.getElementsByClassName('fc-timegrid-axis-frame')[0].scrollWidth;
                setAxisWidth(todayCellWidth);
            }
        };
        getAxisWidth();
        window.addEventListener('resize', function () { return getAxisWidth(); });
        return function () { return window.addEventListener('resize', function () { return getAxisWidth(); }); };
    });
    return (React.createElement("div", { id: "topPositionDatesWrapper", className: st(classes.DatesWrapper), style: {
            width: "100%-".concat(axisWidth, "px"),
            marginLeft: "".concat(axisWidth, "px"),
        } }, currentWeek.map(function (_a, index) {
        var date = _a.date, day = _a.day, weekDay = _a.weekDay, isToday = _a.isToday, momentDate = _a.momentDate;
        var inFocuse = moment(momentDate).format('YYYY-MM-DD') ===
            moment(dateOnFocuse).format('YYYY-MM-DD');
        return (React.createElement("div", { "aria-label": day + ', ' + (date[0] === '0' ? date.substring(1) : date), className: st(classes.RowWrapper, { isLeft: isLeft }), key: index },
            React.createElement(Text, { className: st(classes.WeekDay, { isToday: isToday }) },
                React.createElement("span", { "aria-label": day }, capitalize(weekDay, false))),
            React.createElement("div", { className: st(classes.WeekDateWrapper, {
                    isToday: isToday,
                    inFocuse: inFocuse,
                    isLeft: isLeft,
                }) },
                React.createElement(Text, { className: st(classes.WeekDate, { isToday: isToday }) },
                    React.createElement("span", { "aria-label": date[0] === '0' ? date.substring(1) : date }, date)))));
    })));
};
export default WeeklyDesktopDatesHeader;
//# sourceMappingURL=WeeklyDesktopDatesHeader.js.map